import React, { Component } from 'react';
import {
  Grid, Button, FormControlLabel, Checkbox,
} from '@material-ui/core';
import '../../css/ivrs/ivrsModal.scss';
import ModalHOC from '../common/Modal/index';

export default class ContactUsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose(false);
  };

  render() {
    const { showModal } = this.props;
    return (
      <React.Fragment>
        <ModalHOC
          isOpen={showModal}
          titleContent="Request a custom plan"
          customContent="contact-us-modal"
          onClose={this.handleClose}
          footerComponent={(
            <Grid container>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <FormControlLabel
                  control={<Checkbox value="checkedB" color="primary" />}
                  label="I agree to terms & conditions and privacy policy."
                  className="acknowledgeCheckbox"
                />
              </Grid>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <Button>Request a quote</Button>
              </Grid>
            </Grid>
)}
        >
          <Grid container>
            <p>
              please fillout and submit your content information below and our
              specialist will contact you
            </p>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <h1>Full name</h1>
              <input
                placeholder="type here"
                className="textField inputHead  textfield"
                maxLength={6}
                // onChange={this.handlePincodeChange}
                // value={pincode}
              />
              <h1>Phone Number</h1>
              <input
                placeholder="type here"
                className="textField inputHead  textfield"
                maxLength={6}
                // onChange={this.handlePincodeChange}
                // value={pincode}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <h1>Work Email</h1>
              <input
                placeholder="type here"
                className="textField inputHead  textfield"
                maxLength={6}
                // onChange={this.handlePincodeChange}
                // value={pincode}
              />
              <h1>Company Name</h1>
              <input
                placeholder="type here"
                className="textField inputHead  textfield"
                maxLength={6}
                // onChange={this.handlePincodeChange}
                // value={pincode}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <h1>Comments</h1>
              <textarea
                placeholder="type here"
                className="textField  textfield"
                maxLength={6}
                // onChange={this.handlePincodeChange}
                // value={pincode}
              />
            </Grid>
          </Grid>
        </ModalHOC>
      </React.Fragment>
    );
  }
}
